import React from 'react';

interface NoAccessProps {
  tComponents: (key: string) => string;
}

const NoAccess: React.FC<NoAccessProps> = ({ tComponents }) => {
  return <div>{tComponents('DMFilterSearch.NoAccessMessage')}</div>;
};

export default NoAccess;
